(function($){
/*
$(document).ready(function (e){
	no_cached_buy_links();
});

function no_cached_buy_links () {
	// check si les éléments buy-links sont sur la page

	if ( $('.buy-activator').length ){
		$('.buy-activator').on('click', function (e) {
			e.preventDefault();

			if ( $(this).prev().hasClass('buy-links') ) { // si $('.buy-links') existe
				var $links_container = $(this).prev();

				if ( $($links_container).find('.link').length ) {
					var $links_infos = $($links_container).find('.link');
					var language_ids = [];
					var product_ids = [];

					$($links_infos).each(function (i,e){
						language_ids.push($(e).attr('id').trim());
						product_ids.push($(e).text().trim());
					});

					if ( language_ids.length === product_ids.length ){
						get_api_infos(language_ids, product_ids);
					} else {
						console.error('Error: Links informations are not complete.');
					}
				} else {
					console.error('Error: No link found for this item');
				}
			}
			return false;
		});
	}
}

function get_api_infos(language_ids, product_ids) {

	$.ajax({
		url: ajax.url,
		method:'POST',
		data: {
			action : 'get_url',
			language_ids : language_ids,
			product_ids : product_ids,
		},
		success: function(response) {
			if ( response !== 'error' ) {
				window.open(response, '_blank');
			} else {
				console.error('Error: An error occured')
			}
		},
	});
}
*/
})(jQuery);